import { useEffect } from "react";
import { store } from "../..";

export const timeList = [
    { value: "", label: "Select time" },
    { value: "06:00", label: "06:00 AM" },
    { value: "06:30", label: "06:30 AM" },
    { value: "07:00", label: "07:00 AM" },
    { value: "07:30", label: "07:30 AM" },
    { value: "08:00", label: "08:00 AM" },
    { value: "08:30", label: "08:30 AM" },
    { value: "09:00", label: "09:00 AM" },
    { value: "09:30", label: "09:30 AM" },
    { value: "10:00", label: "10:00 AM" },
    { value: "10:30", label: "10:30 AM" },
    { value: "11:00", label: "11:00 AM" },
    { value: "11:30", label: "11:30 AM" },
    { value: "12:00", label: "12:00 PM" },
    { value: "12:30", label: "12:30 PM" },
    { value: "13:00", label: "01:00 PM" },
    { value: "13:30", label: "01:30 PM" },
    { value: "14:00", label: "02:00 PM" },
    { value: "14:30", label: "02:30 PM" },
    { value: "15:00", label: "03:00 PM" },
    { value: "15:30", label: "03:30 PM" },
    { value: "16:00", label: "04:00 PM" },
    { value: "16:30", label: "04:30 PM" },
    { value: "17:00", label: "05:00 PM" },
    { value: "17:30", label: "05:30 PM" },
    { value: "18:00", label: "06:00 PM" },
    { value: "18:30", label: "06:30 PM" },
    { value: "19:00", label: "07:00 PM" },
    { value: "19:30", label: "07:30 PM" },
    { value: "20:00", label: "08:00 PM" },
    { value: "20:30", label: "08:30 PM" },
    { value: "21:00", label: "09:00 PM" },
];

export const lunchBreakFrom = [
    { value: "", label: "Select time" },
    { value: "12:00", label: "12:00 PM" },
    { value: "12:30", label: "12:30 PM" },
    { value: "13:00", label: "01:00 PM" },
    { value: "13:30", label: "01:30 PM" },
    { value: "14:00", label: "02:00 PM" },
    { value: "14:30", label: "02:30 PM" },
];

export const lunchBreakTo = [
    { value: "", label: "Select time" },
    { value: "12:00", label: "12:00 PM" },
    { value: "12:30", label: "12:30 PM" },
    { value: "13:00", label: "01:00 PM" },
    { value: "13:30", label: "01:30 PM" },
    { value: "14:00", label: "02:00 PM" },
    { value: "14:30", label: "02:30 PM" },
    { value: "15:00", label: "03:00 PM" },
    { value: "15:30", label: "03:30 PM" },
];

export const parseTime = (timeString) => {
    const [hours, minutes] = timeString.split(":").map(Number);
    return { hours, minutes };
};

export const initialScheduler = [
    {
        day: "Monday",
        isClose: false,
        openTime: "",
        closeTime: "",
    },
    {
        day: "Tuesday",
        isClose: false,
        openTime: "",
        closeTime: "",
    },
    {
        day: "Wednesday",
        isClose: false,
        openTime: "",
        closeTime: "",
    },
    {
        day: "Thursday",
        isClose: false,
        openTime: "",
        closeTime: "",
    },
    {
        day: "Friday",
        isClose: false,
        openTime: "",
        closeTime: "",
    },
    {
        day: "Saturday",
        isClose: false,
        openTime: "",
        closeTime: "",
    },
    {
        day: "Sunday",
        isClose: false,
        openTime: "",
        closeTime: "",
    },
    {
        day: "Lunch Break",
        isClose: false,
        openTime: "",
        closeTime: "",
    },
];

export const durationList = [
    { value: "", label: "Select time" },
    { value: "10", label: "10 min" },
    { value: "15", label: "15 min" },
    { value: "30", label: "30 min" },
    { value: "45", label: "45 min" },
    { value: "60", label: "1 hr" },
    { value: "90", label: "1.5 hr" },
    { value: "120", label: "2 hr" },
];

export const procedureList = [
    { name: "Any Procedure", id: "ddlpdap" },
    { name: "Dental Consultation", id: "ddlpdconsult" },
    { name: "Dental Follow Up", id: "ddlpddfu" },
    { name: "Dental Cleaning", id: "ddlpdcleaning" },
    { name: "Emergency Dentist Visit", id: "ddlpdedv" },
    { name: "Braces", id: "ddlpdbrace" },
    { name: "Bridge", id: "ddlpdbridge" },
    { name: "Crown", id: "ddlpdcrown" },
    { name: "Dentures", id: "ddlpddenture" },
    { name: "Filling", id: "ddlpdfilling" },
    { name: "Gum Surgery", id: "ddlpdsurgery" },
    { name: "Implant", id: "ddlpdimplant" },
    { name: "Invisalign", id: "ddlpdinvis" },
    { name: "Retainers", id: "ddlpdretain" },
    { name: "Root Canal", id: "ddlpdcanal" },
    { name: "Tooth Extraction", id: "ddlpdextract" },
    { name: "Tooth Whitening", id: "ddlpdtw" },
    { name: "Venners", id: "ddlpdvenner" },
    { name: "Wisdom Tooth Problem", id: "ddlpdwtp" },
];

export const initialProcedureList = [
    { procedureType: "Any Procedure", duration: "" },
    { procedureType: "Dental Consultation", duration: "" },
    { procedureType: "Dental Follow Up", duration: "" },
    { procedureType: "Dental Cleaning", duration: "" },
    { procedureType: "Emergency Dentist Visit", duration: "" },
    { procedureType: "Braces", duration: "" },
    { procedureType: "Bridge", duration: "" },
    { procedureType: "Crown", duration: "" },
    { procedureType: "Dentures", duration: "" },
    { procedureType: "Filling", duration: "" },
    { procedureType: "Gum Surgery", duration: "" },
    { procedureType: "Implant", duration: "" },
    { procedureType: "Invisalign", duration: "" },
    { procedureType: "Retainers", duration: "" },
    { procedureType: "Root Canal", duration: "" },
    { procedureType: "Tooth Extraction", duration: "" },
    { procedureType: "Tooth Whitening", duration: "" },
    { procedureType: "Venners", duration: "" },
    { procedureType: "Wisdom Tooth Problem", duration: "" },
];

export const countryList = [
    { value: "en-AU", label: "Australia" },
    { value: "en-CA", label: "Canada" },
    { value: "en-GB", label: "United Kingdom" },
    { value: "en-US", label: "United States" },
];

export const getCultureString = (country) => {
    switch (country) {
        case "United Kingdom":
            return "en-GB";
        case "Australia":
            return "en-AU";
        case "United States":
            return "en-US";
        case "Canada":
            return "en-CA";
        default:
            return "";
    }
};

export const initRegionalStates = {
    NumberDecimalDigits: "2",
    NumberGroupSeparator: ",",
    NumberNegativePattern: "0",
    NumberGroupSizes: "",

    CurrencyDecimalDigits: "2",
    CurrencyGroupSeparator: ",",
    CurrencyPositivePattern: "0",
    CurrencyNegativePattern: "0",

    ShortTimePattern: "h:mm tt",
    ShortDatePattern: "MMM d, yyyy",
    Country: "en-US",
};

export const initRegionalSettings = {
    NumberDecimalDigits: "2",
    NumberGroupSeparator: ",",
    NumberNegativePattern: "(n)",
    NumberGroupSizes: "",

    CurrencyDecimalDigits: "2",
    CurrencyGroupSeparator: ",",
    CurrencyPositivePattern: "$n",
    CurrencyNegativePattern: "($n)",

    ShortTimePattern: "h:mm tt",
    ShortDatePattern: "MMM d, yyyy",
    Country: "en-US",
};

export const decimalDigitsOptions = ["0", "1", "2"];

export const currencyDecimalDigitsOptions = ["0", "1", "2"];

export const negativeNumberFormatOptions = [
    { value: "0", label: "(n)" },
    { value: "1", label: "-n" },
    { value: "2", label: "- n" },
    { value: "3", label: "n-" },
    { value: "4", label: "n -" },
];

export const shortTimeFormatOptions = ["h:mm tt", "hh:mm tt", "H:mm", "HH:mm"];

export const shortDateFormatOptions = [
    "M/d/yyyy",
    "M/d/yy",
    "MM/dd/yy",
    "MM/dd/yyyy",
    "yy/MM/dd",
    "yyyy-MM-dd",
    "dd-MMM-yy",
];

export const appointmentNotificationList = [
    {
        type: "open.unconfirm",
        isChecked: false,
    },
    {
        type: "open.confirm",
        isChecked: false,
    },
    {
        type: "complete.unconfirm",
        isChecked: false,
    },
    {
        type: "complete.confirm",
        isChecked: false,
    },
    {
        type: "Fixed",
        isChecked: false,
    },
    {
        type: "Open",
        isChecked: false,
    },
    {
        type: "General",
        isChecked: false,
    },
];

export const getRegionalData = (arr) => {
    const obj = {};

    arr.forEach((i) => {
        if (i.attributeName === "Country") {
            obj[i.attributeName] = getCultureString(i.attributeValue);
        } else {
            obj[i.attributeName] = i.attributeValue;
        }
    });
    return { ...initRegionalStates, ...obj };
};

export const initPreview = {
    positiveNumber: "",
    negativeNumber: "",
    positiveCurrency: "",
    negativeCurrency: "",
    shortTime: "",
    shortDate: "",
};

export const formatNumWithDigits = (num, digits) => {
    if (digits === "1") return num + ".0";
    if (digits === "2") return num + ".00";
    return num;
};

export const formatPattern = (num, pattern, options) => {
    const opt = options.find((i) => i.value === pattern);
    if (opt) {
        return opt.label.replace("n", num);
    }

    return num;
};

export const getCurrentTimeFormatted = (format) => {
    const currentTime = new Date();
    const hour = currentTime.getHours();
    const minute = currentTime.getMinutes();
    const ampm = hour >= 12 ? "PM" : "AM";

    switch (format) {
        case "h:mm tt":
            return `${hour % 12 || 12}:${minute
                .toString()
                .padStart(2, "0")} ${ampm}`;
        case "hh:mm tt":
            return `${(hour % 12).toString().padStart(2, "0")}:${minute
                .toString()
                .padStart(2, "0")} ${ampm}`;
        case "H:mm":
            return `${hour}:${minute.toString().padStart(2, "0")}`;
        case "HH:mm":
            return `${hour.toString().padStart(2, "0")}:${minute
                .toString()
                .padStart(2, "0")}`;
        default:
            return "";
    }
};

export const getCurrentDateFormatted = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-based, so add 1
    const day = currentDate.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const settingsTabs = [
    {
        label: "Practice Details",
        width: 158,
        imgUrl: "https://s3.amazonaws.com/dpm2.0/Icons/DocumentOutline.svg",
    },
    {
        label: "Sikka Scores",
        width: 158,
        imgUrl: "https://s3.amazonaws.com/dpm2.0/Icons/Chart.svg",
    },
    {
        label: "User Management",
        width: 158,
        imgUrl: "https://s3.amazonaws.com/dpm2.0/Icons/User.svg",
    },
    {
        label: "Payments",
        width: 158,
        imgUrl: "https://s3.amazonaws.com/dpm2.0/Icons/Dollar.svg",
    },
    {
        label: "Schedule & Duration",
        width: 158,
        imgUrl: "https://s3.amazonaws.com/dpm2.0/Icons/Calendar.svg",
    },
    {
        label: "Regional Settings",
        width: 158,
        imgUrl: "https://s3.amazonaws.com/dpm2.0/Icons/Settings.svg",
    },
    {
        label: "Appointments",
        width: 158,
        imgUrl: "https://s3.amazonaws.com/dpm2.0/Icons/Checklist.svg",
    },
    {
        label: "Provider Mapping",
        width: 158,
        imgUrl: "https://s3.amazonaws.com/dpm2.0/Icons/UserGroup.svg",
    },
    // {
    //     label: "Insurance Fee Mapping",
    //     width: 158,
    //     imgUrl: "https://s3.amazonaws.com/dpm2.0/Icons/CheckReceipt_Gray.svg",
    // },
];

export const initialUserValues = {
    firstName: "",
    lastName: "",
    email: "",
    user_Type: "Regular User", //dropdown
    password: "",
    confirmPassword: "",
    city: "",
    state: "",
    zipCode: "",
    country: "United States", //dropdown
};

export default function useSetPracticeData(setSelectedPractice, setPractices) {
    const state = store.getState().dataReducer;
    const { activeItem } = state;

    useEffect(() => {
        if (activeItem["type"] === "solo") {
            setSelectedPractice(activeItem.items[0]);
            setPractices([]);
        } else {
            setSelectedPractice(null);
            setPractices(activeItem.items);
        }
    }, [activeItem]);
}
